import React from 'react';
import PropTypes from 'prop-types';

import { StyledInputWithLabel } from 'lib/styles';

import {
	ErrorMessage,
	Button,
} from '../Login';


const EmailForm = props => {
	const { t } = props;
	const invalidMail = props.username.indexOf('@') === -1 || props.username.indexOf('.') === -1;

	return (
		<React.Fragment>
			<h1 style={{marginTop: 0}}>{t('login/Order new password')}</h1>

			{ !props.emailSent &&
			<React.Fragment>
			  <StyledInputWithLabel
			    label={t('login/username')}
			    type="email"
			    defaultValue={props.username}
			    name="username"
			    onChange={event => props.handleInputChange(event)}
			    onBlur={event => props.handleInputBlur(event)} />

			  { props.error &&
					<ErrorMessage>{t(props.error)}</ErrorMessage>
			  }

			  <Button
			    type="submit"
			    disabled={invalidMail}
			  >{props.buttonText}</Button>
			</React.Fragment>
			}
			{ props.emailSent &&
			<p>{t('login/Password link in email')}</p>
			}
		</React.Fragment>
	)
}

EmailForm.propTypes = {
	emailSent: PropTypes.bool,
	error: PropTypes.any,
	username: PropTypes.string,
	buttonText: PropTypes.string,
	handleInputBlur: PropTypes.func,
	handleInputChange: PropTypes.func,
	t: PropTypes.func,
}

export default EmailForm
